import type { TranslationModule } from '../types';

export const footerTranslations: TranslationModule = {
  ro: {
    aboutUs: "Despre Noi",
    presentation: "Prezentare Platformă",
    timeline: "Timeline Ecosistem",
    userManual: "Manual de Utilizare",
    companyDesc: "VERDICT LINE S.R.L. - Soluții avansate de cercetare juridică și analiză de spețe. CUI 50104199.",
    verdictGroup: "Grup Verdict Line",
    content: "Conținut",
    videoJuridic: "Video Juridic",
    legalSupport: "Legal & Suport",
    terms: "Termeni și Condiții",
    privacy: "Politica de Confidențialitate",
    cookies: "Politica Cookies",
    gdpr: "GDPR",
    security: "Securitate Platformă",
    sources: "Surse Date Prelucrate",
    returnPolicy: "Politică de retur",
    helpCenter: "Centru de Ajutor",
    sitemap: "Harta Site",
    address: "Str. DRM. DÂRVARI, Nr. 34A, Sector 5, București",
    contactUs: "Contactează-ne",
    rightsReserved: "Toate drepturile rezervate.",
    developedWith: "Dezvoltat cu pasiune pentru justiție.",
    aiSolutions: "Soluții Juridice AI",
    legalSchemes: "Scheme Juridice",
    legalArticles: "Articole Juridice",
    publishArticles: "Publicare Articole Juridice",
    legalWebsites: "Site-uri Juridice din România",
    financialMarkets: "Piețe Financiare",
    legislativeChanges: "Modificări legislative la zi"
  },
  en: {
    aboutUs: "About Us",
    presentation: "Platform Presentation",
    timeline: "Ecosystem Timeline",
    userManual: "User Manual",
    companyDesc: "VERDICT LINE S.R.L. - Advanced solutions for legal research and case law analysis. CUI 50104199.",
    verdictGroup: "Verdict Line Group",
    content: "Content",
    videoJuridic: "Legal Video",
    legalSupport: "Legal & Support",
    terms: "Terms & Conditions",
    privacy: "Privacy Policy",
    cookies: "Cookie Policy",
    gdpr: "GDPR Compliance",
    security: "Platform Security",
    sources: "Processed Data Sources",
    returnPolicy: "Refund Policy",
    helpCenter: "Help Center",
    sitemap: "Sitemap",
    address: "34A DRM. DARVARI St., Sector 5, Bucharest, Romania",
    contactUs: "Contact Us",
    rightsReserved: "All rights reserved.",
    developedWith: "Developed with passion for justice.",
    aiSolutions: "AI Legal Solutions",
    legalSchemes: "Legal Diagrams",
    legalArticles: "Legal Articles",
    publishArticles: "Publish Legal Articles",
    legalWebsites: "Legal Websites in Romania",
    financialMarkets: "Financial Markets",
    legislativeChanges: "Daily legislative changes"
  },
  fr: {
    aboutUs: "À Propos de Nous",
    presentation: "Présentation de la Plateforme",
    timeline: "Chronologie de l'Écosystème",
    userManual: "Manuel d'Utilisation",
    companyDesc: "VERDICT LINE S.R.L. - Solutions avancées pour la recherche juridique et l'analyse de jurisprudence. CUI 50104199.",
    verdictGroup: "Groupe Verdict Line",
    content: "Contenu",
    videoJuridic: "Vidéo Juridique",
    legalSupport: "Légal & Support",
    terms: "Conditions Générales",
    privacy: "Politique de Confidentialité",
    cookies: "Politique relative aux Cookies",
    gdpr: "Conformité RGPD",
    security: "Sécurité de la Plateforme",
    sources: "Sources des Données Traitées",
    returnPolicy: "Politique de Retour",
    helpCenter: "Centre d'Aide",
    sitemap: "Plan du Site",
    address: "Rue DRM. DARVARI, No. 34A, Secteur 5, Bucarest, Roumanie",
    contactUs: "Contactez-nous",
    rightsReserved: "Tous droits réservés.",
    developedWith: "Développé avec passion pour la justice.",
    aiSolutions: "Solutions Juridiques IA",
    legalSchemes: "Schémas Juridiques",
    legalArticles: "Articles Juridiques",
    publishArticles: "Publication d'Articles Juridiques",
    legalWebsites: "Sites Juridiques en Roumanie",
    financialMarkets: "Marchés Financiers",
    legislativeChanges: "Modifications législatives au quotidien"
  }
};

export default footerTranslations;
